// extracted by mini-css-extract-plugin
module.exports = {"tick":"style_tick__2SLar","isMinute":"style_isMinute__1zUHU"};